import BannerNav from "@/Components/bannerNav/bannerNav";
import WhatsAppButton from "@/Components/botonWsp/whatsapp-button";
import BottomNav from "@/Components/bottomNav/BottomNav";
import Footer from "@/Components/footer/footer";
import Nav from "@/Components/navbar/nav";
import TopNav from "@/Components/topNav/topNav";
import "@/styles/styles.scss";

const LayoutPrincipal = ({ children }: { children: React.ReactNode }) => {
    const exptionUrl = [
        `${window.location.origin}/checkout/cart`,
        `${window.location.origin}/checkout/form`
    ];
    const isException = exptionUrl.includes(window.location.href);
    return (

        <>
            <TopNav props="style-three bg-white" />
            <div id="header" className="relative w-full flex flex-col">
                <Nav />
                <BottomNav />
                <BannerNav props="py-3" bgLine="bg-black" />
            </div>

            <div className="min-h-screen flex flex-col">
                <div className="flex-grow">{children}</div>
                {!isException && (
                    <WhatsAppButton
                        pulseAnimation={true}
                    />
                )}
                <Footer />
            </div>
        </>
    );
};

export default LayoutPrincipal;
